export default __webpack_public_path__ + "static/media/E-KYC-3.7c736441.png";